import { render, staticRenderFns } from "./assetStatusStatistics.vue?vue&type=template&id=8f0ec206&scoped=true&"
import script from "./assetStatusStatistics.vue?vue&type=script&lang=js&"
export * from "./assetStatusStatistics.vue?vue&type=script&lang=js&"
import style0 from "./assetStatusStatistics.vue?vue&type=style&index=0&id=8f0ec206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0ec206",
  null
  
)

export default component.exports